import { jsx as _jsx } from "react/jsx-runtime";
/* Техстраница «платформа остановлена» — тонкая обёртка над ServicePage кита (kit-v5.18.0,
   platform/kit/v5/src/templates/service.jsx): вёрстка, тексты и три состояния (restoring/
   updating/failed) целиком в ките, здесь только поверхность getServiceState() и viewport.
   Рисуется вместо ВСЕГО остального (и до входа, и внутри сессии), пока взведён
   platformStateStore (T-SET-5) — переключение остаётся в App.tsx. */
import { useEffect, useState } from "react";
import { ServicePage } from "@kit-v5";
import { PLATFORM_RESTORE_CODES } from "../api/client";
import { t } from "../i18n/i18n";
import { mapServiceSteps } from "./serviceSteps";
const MOBILE_BREAKPOINT = 760;
function useServiceViewport() {
    const [vp, setVp] = useState(() => (window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop"));
    useEffect(() => {
        const onResize = () => setVp(window.innerWidth < MOBILE_BREAKPOINT ? "mobile" : "desktop");
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    return vp;
}
// getServiceState — поверхность, которую опрашивает ServicePage кита: GET /api/status,
// 503 с кодом маркера состояния → {state, since, reason} из тела ошибки (контракт client.ts);
// 200 → "ready" (не входит в COPY шаблона — тот сам перезагружает страницу); сетевую ошибку
// не гасим — бросаем дальше, шаблон молча ждёт следующего тика опроса.
async function getServiceState() {
    const res = await fetch("/api/status", { method: "GET", credentials: "same-origin" });
    if (res.ok)
        return { state: "ready", since: "", reason: "" };
    let body = null;
    try {
        body = await res.json();
    }
    catch { /* тело могло не прийти */ }
    const e = body?.error;
    if (res.status === 503 && e?.code && PLATFORM_RESTORE_CODES.has(e.code)) {
        return {
            state: e.state ?? "restoring",
            since: e.since ?? "",
            reason: e.reason ?? "",
            steps: mapServiceSteps(e.steps, t),
            backTo: e.backTo ?? "",
        };
    }
    return { state: "ready", since: "", reason: "" };
}
const serviceApi = { getServiceState };
export default function Maintenance() {
    const vp = useServiceViewport();
    return _jsx(ServicePage, { api: serviceApi, vp: vp });
}
